import {_serializeSingle, _serializeList} from './core';
import type {ServerData} from './core';
import type {SerializedWithRaw} from './core';
import type {DomainOf} from '../../../types/domain';

// Webhook
/** 스키마 밖에서 조립되는 관계 필드 — 서버 응답 계약의 일부. */
type WebhookBffExtras = {hookEvents?: DomainOf<"hookEvent">[]};
type WebhookHistoryBffExtras = {attempts?: unknown[]};

export function serializeWebhook(data: ServerData) {
    return _serializeSingle("webhook", data);
}

export function serializeWebhookList(data: ServerData) {
    return _serializeList("webhook", data);
}

// Webhook BFF
export function serializeWebhookBff(data: ServerData) {
    if (!data) return null;
    const webhook: DomainOf<"webhook"> & WebhookBffExtras = _serializeSingle("webhook", data);
    if (data.hookEvents) webhook.hookEvents = serializeHookEventList(data.hookEvents);
    return webhook;
}

export function serializeWebhookBffList(data: ServerData) {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => serializeWebhookBff(item));
}

// Webhook History
export function serializeWebhookHistory(data: ServerData) {
    return _serializeSingle("webhookHistory", data);
}

export function serializeWebhookHistoryList(data: ServerData) {
    return _serializeList("webhookHistory", data);
}

export function serializeWebhookHistoryAttempt(data: ServerData): SerializedWithRaw<"webhookHistoryAttempt"> | null {
    if (!data) return null;
    return {
        ...data,
        ..._serializeSingle("webhookHistoryAttempt", data),
    };
}

export function serializeWebhookHistoryAttemptList(data: ServerData) {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => serializeWebhookHistoryAttempt(item));
}

// 상세(시도 이력 포함). attempts 는 평면 도메인 키가 아닌 별도 배열로 부착.
export function serializeWebhookHistoryBff(data: ServerData) {
    if (!data) return null;
    const h: DomainOf<"webhookHistory"> & WebhookHistoryBffExtras = _serializeSingle("webhookHistory", data);
    h.attempts = serializeWebhookHistoryAttemptList(data.attempts);
    return h;
}

// Hook Event
export function serializeHookEvent(data: ServerData) {
    return _serializeSingle("hookEvent", data);
}

export function serializeHookEventList(data: ServerData) {
    return _serializeList("hookEvent", data);
}
